
<template>

	<div>

		<formula v-if="version.attrs.cost && version.attrs.UPKS && !version.group.cost_evaluation_individual" class="mt-2" :version="version"/>
		
		<modeling class="mt-2" v-if="version.group.cost_evaluation_comparative && version.group.cost_evaluation_comparative.type == 'Метод статистического (регрессионного) моделирования'" :version="version" :attrs="attrs"/>
		<expensive class="mt-2" v-if="version.group.cost_evaluation_expensive && version.group.cost_evaluation_expensive.type == 'Метод сравнительной единицы'" :version="version"/>
		<individual class="mt-2" v-if="version.group.cost_evaluation_individual && version.group.cost_evaluation_individual.type == 'Индивидуальный расчет'" :version="version"/>

		<profitable v-if="version.group.cost_evaluation_profitable && version.group.cost_evaluation_profitable.type == 'Метод прямой капитализации'" :version="version"/>

	</div>

</template>

<script>
import modeling from "./modeling"
import expensive from "./expensive"
import profitable from "./profitable"
import individual from "./individual"
import formula from "./formula"

export default
{
	props :
	{
		object_id : String,
		version : Object,
		correction_types : Array,
		attrs : Array,
		functional_sub_group_reference : Object,
	},

	components :
	{
		modeling,
		expensive,
		profitable,
		individual,
		formula,
	},

	data()
	{
		return {

			service : "cadastral_objects",

		}
	},
}

</script>

